import gql from 'graphql-tag';

export default gql`
    mutation UpdateJobProfile($input: JobProfileEdit) {
        updateJobProfile(input: $input) {
            errors
        }
    }
`;
